import Service 							from "./../../Libs/Service";

import { Server } 						from "./Server";
import _ from "lodash";
import dayjs from "dayjs";

let TrackingEvent = new Service({

	Name: "TrackingEvent",

	Libraries: [],

	Events: {},

	Actions: {

		"Events": function (events) {

			this.setEventsByCampaign(events);

			Broadcast.call("Events Fetched");

		},

		"ImpressionsByOrder": function (impressions) {

			this.setOrdersWithImpressions(impressions);

			Broadcast.call("Impressions For Orders Fetched");

		}
	},


	init() {
		this.Events = {};
		this.CampaignsWithEvents = {};
		this.OrdersWithImpressions = {};
		this.lastUpdate = false;
		this.lastUpdateForOrders = false;
	},

	setOrdersWithImpressions(impressions) {

		this.OrdersWithImpressions = {};

		const orders = Object.values(Order.Orders);

		orders.forEach(order => {

			this.setOrderWithImpressions(order, impressions[order.id]);

		});

		this.lastUpdateForOrders = Date.now();

	},

	setEventsByCampaign(events) {

		this.CampaignsWithEvents = {};

		const campaigns = Object.values(Order.Campaigns);

		campaigns.forEach(campaign => {

			this.setCampaignWithEvents(campaign, events[campaign.id]);

		});

		this.lastUpdate = Date.now();

	},

	setOrderWithImpressions(order, impressions_counts = {}) {

		const data = {};

		data.id = order.id;
		data.name = order.name;
		data.active = order.active;
		data.impression_price = order.impression_price;

		data.installs = impressions_counts.total_impression_count || 0;
		if (impressions_counts.latest_event) {
			data.latest_event = dayjs(impressions_counts.latest_event);
		}

		const existingOrderWithImpressions = this.OrdersWithImpressions[order.id];
		if (existingOrderWithImpressions) {
			data.installs = existingOrderWithImpressions.installs;
			data.latest_event = existingOrderWithImpressions.latest_event;
		}

		data.spend = data.installs * data.impression_price;

		this.OrdersWithImpressions[order.id] = data;

	},

	setCampaignWithEvents(campaign, metrics = {}) {

		if (!Object.keys(metrics).length && this.CampaignsWithEvents[campaign.id]) {
			metrics = this.CampaignsWithEvents[campaign.id].metrics || {};
		}

		const order = Order.Orders[campaign.order_id];

		const data = {};

		if (metrics.latest_event) {
			data.latest_event = dayjs(metrics.latest_event);
		}

		data.metrics = metrics;
		data.id = campaign.id;
		data.active = order.active;
		data.order_name = order.name;
		data.name = campaign.name;

		this.CampaignsWithEvents[campaign.id] = data;

	},

	getOrdersWithImpressions() {
		// return Object.values(this.OrdersWithImpressions).concat(Object.values(this.OrdersWithImpressions)).concat(Object.values(this.OrdersWithImpressions)).concat(Object.values(this.OrdersWithImpressions));
		return Object.values(this.OrdersWithImpressions);
	},

	getCampaignsWithEvents() {
		return Object.values(this.CampaignsWithEvents);
	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.TrackingEvent) TrackingEvent = window.TrackingEvent;
else window.TrackingEvent = TrackingEvent;

export { TrackingEvent }
